import Konva from 'konva';

export default class LabelledCircle extends Konva.Group {
  constructor(config) {
    super(config);
    this._radius = config.radius || 30;
    this._fill = config.fill || "white";
    this._stroke = config.stroke || "black";
    this._strokeWidth = config.strokeWidth || 2;
    this._text = config.text || "";
    this._fontSize = config.fontSize || 20;
    this.initializeComponents();
  }

  initializeComponents() {
    this.circle = new Konva.Circle({
      radius: this._radius,
      fill: this._fill,
      stroke: this._stroke,
      strokeWidth: this._strokeWidth,
      visible: true,
    });

    this.label = new Konva.Text({
      x: -this._radius,
      y: -this._radius,
      width: this._radius * 2,
      height: this._radius * 2,
      text: this._text,
      fontSize: this._fontSize,
      align: "center",
      verticalAlign: "middle",
      visible: true,
    });

    this.add(this.circle);
    this.add(this.label);
    this.circle.zIndex(0);
    this.label.zIndex(1);
  }

  text(newText) {
    return this.label.text(newText)
  }

  stroke(col) {
    return this.circle.stroke(col);
  }

  fill(col) {
    return this.circle.fill(col);
  }

  radius(r) {
    if (!r) {
      return _radius;
    }
    this._radius = r;
    this.circle.radius(r);
    this.label.x(-r);
    this.label.y(-r);
    this.label.width(r * 2);
    this.label.height(r * 2);
  }
}
